import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage'
import { faSparkles } from '@fortawesome/pro-regular-svg-icons/faSparkles'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { ActionIcon, FileButton, Flex, type FlexProps } from '@mantine/core'
import React from 'react'

import { type CoreBundle, type CoreItem } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { type ItemPhotoForManager } from './GridItemPhotosManager'
import styles from './styles.module.css'
import { useGridItemPhotosManagerState } from './useGridItemPhotosManagerState'

type BoxActionsProps = FlexProps & {
  product?: CoreItem | CoreBundle
  photo?: ItemPhotoForManager
}

export function BoxActions({ product, photo, ...props }: BoxActionsProps) {
  const resetRef = React.useRef<() => void>(null)

  const { deletePhoto, uploadPhoto, generateSinglePhotoWithAI } =
    useGridItemPhotosManagerState()

  const handleUploadImage = (file: File | null) => {
    if (!file) {
      return
    }

    uploadPhoto(file, photo?.order ?? 0)
  }

  const handleRemoveImage = () => {
    deletePhoto(photo?.order ?? 0)
  }

  const handleGenerateImageWithAI = () => {
    generateSinglePhotoWithAI(product?.title ?? '', photo?.order ?? 0)
  }

  return (
    <Flex
      {...props}
      gap='xs'
      w='100%'
      justify={photo?.main ? 'flex-end' : 'center'}
      {...(photo?.main && { pr: 'md' })}
    >
      <ActionIcon
        className={styles.action}
        onClick={handleGenerateImageWithAI}
        variant='default'
        radius='xs'
        size='xs'
        data-testid='btn-generate'
      >
        <Icon icon={faSparkles} />
      </ActionIcon>

      <FileButton
        resetRef={resetRef}
        onChange={handleUploadImage}
        accept='image/png,image/jpeg'
      >
        {(props) => (
          <ActionIcon
            {...props}
            className={styles.action}
            variant='default'
            size='xs'
            radius='xs'
            data-testid='btn-upload'
            onClick={() => props.onClick()}
          >
            <Icon icon={faImage} />
          </ActionIcon>
        )}
      </FileButton>

      <ActionIcon
        className={styles.action}
        variant='default'
        size='xs'
        radius='xs'
        onClick={handleRemoveImage}
        data-testid='btn-delete'
      >
        <Icon icon={faTrash} />
      </ActionIcon>
    </Flex>
  )
}
